import React, { FC, ReactNode } from 'react'
import { Wrapper, Item, Info, Text, Title } from './styled'

interface ComponentProps {
	number: string
	title?: string | (() => ReactNode)
	text?: string | (() => ReactNode)
}

export const ProcedureElement: FC<ComponentProps> = ({ number, title = '', text = '' }) => (
	<Wrapper>
		<Item>{number}</Item>
		<Info>
			{typeof title === 'function' ? title?.() : <Title>{title}</Title>}
			{typeof text === 'function' ? text?.() : <Text>{text}</Text>}
		</Info>
	</Wrapper>
)
